import { useEffect, useState } from "react"
import keycloak from "./keycloak"
import axios from "axios"
import { Typography } from "@mui/material"
import { KeycloakContext } from "./keycloakContext"

let axiosInterceptorId = null

const ErrorMessage = () => {
  return (
    <>
      <Typography>
        We could not initialize authentication. Please try again later or
        contact support.
      </Typography>
      <button
        onClick={async () => {
          window.location.reload()
        }}
      >
        Try again
      </button>
    </>
  )
}

const UnAuthMessage = ({ keycloak }) => {
  return (
    <>
      <Typography>
        Unauthorized. Please ask your administrator to grant you access.
      </Typography>
      <button
        onClick={async () => {
          await keycloak.updateToken(0)
          window.location.reload()
        }}
      >
        I've been granted access - try again
      </button>
      <button
        onClick={async () => {
          keycloak.logout()
        }}
      >
        Logout
      </button>
    </>
  )
}

const KcWrapper = ({ children }) => {
  const [state, setState] = useState("loading")

  useEffect(() => {
    keycloak
      .init({ onLoad: "login-required" })
      .then(() => {
        const { REACT_APP_KEYCLOAK_CLIENT_ID, REACT_APP_KEYCLOAK_CLIENT_ROLE } =
          process.env

        const hasRole = keycloak.hasResourceRole(
          REACT_APP_KEYCLOAK_CLIENT_ROLE,
          REACT_APP_KEYCLOAK_CLIENT_ID,
        )

        if (!hasRole) {
          setState("unauthorized")
          return
        }

        // Add Axios interceptor once
        if (axiosInterceptorId === null) {
          axiosInterceptorId = axios.interceptors.request.use(async (cfg) => {
            try {
              await keycloak.updateToken(5) // refresh if <5s left
            } catch (err) {
              console.error("Token refresh failed", err)
              keycloak.logout({ redirectUri: window.location.origin })
              throw err
            }

            if (keycloak.token) {
              cfg.headers.Authorization = `Bearer ${keycloak.token}`
            }
            return cfg
          })
        }

        setState("ready")
      })
      .catch((err) => {
        console.error("Keycloak initialization failed", err)
        setState("error")
      })
    // Cleanup function to eject Axios interceptor on unmount
    return () => {
      if (axiosInterceptorId !== null) {
        axios.interceptors.request.eject(axiosInterceptorId)
        axiosInterceptorId = null
      }
    }
  }, [])

  // Render based on state
  if (state === "loading") return <Typography>Loading…</Typography>
  if (state === "unauthorized") return <UnAuthMessage keycloak={keycloak} />
  if (state === "error") return <ErrorMessage />

  // Inject keycloak into child via cloneElement
  return (
    <KeycloakContext.Provider value={keycloak}>
      {children}
    </KeycloakContext.Provider>
  )
}

export default KcWrapper
